enum ConfigurationEnum {
  apiHost = 'VUE_APP_MC3',
  version = 'VUE_APP_VERSION',
  azureClientId = 'VUE_APP_AZURECLIENTID',
  azureTenantId = 'VUE_APP_AZURETENANTID',
  azureSecret = 'VUE_APP_AZURESECRET',
  visualCrossingApiKey = 'VUE_APP_VISUAL_CROSSING_API_KEY',
  openWeatherApiKey = 'VUE_APP_OPEN_WEATHER_API_KEY',

  opusAPIURL = 'VUE_APP_OPUS_API_URL',
  newOpusAPIURL = 'VUE_APP_NEW_OPUS_API_URL',
  PDFRenderAPIURL = 'VUE_APP_PDF_RENDER_API_URL',
}

export default ConfigurationEnum
